import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

export const DefaultFormatter = ({ index }) => {
  return (
    <>
      {index === 0 ? (
        <Typography data-qe-id="DefaultRate">
          <FormattedMessage id="advancedRateCard.defaultRate" />
        </Typography>
      ) : null}
    </>
  );
};

DefaultFormatter.propTypes = {
  index: PropTypes.number
};

export default DefaultFormatter;
